module.exports = __webpack_public_path__ + "static/media/inf_92og93.2bb2809a.mp3";